module.exports = __webpack_public_path__ + "img/Niue.9a97fb22.png";